import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Check, CheckCircle, X } from 'lucide-react';
import Footer from './ZeronineFooter';
import Navigation from './ZeronineHeader';
import { getSettingForWeb } from '../../redux/actions/package';

const RefundPolicy = () => {
   const dispatch = useDispatch();
   const WebSetting = useSelector((state) => state.Package?.webSetting || []);

   useEffect(() => {
      dispatch(getSettingForWeb());
   }, [dispatch]);

   // Get refund policy content from WebSetting
   const refundPolicyContent = WebSetting[0]?.refundPolicy || '';

   return (
      <>
         <Navigation />
         <div className="min-h-screen bg-gradient-to-br from-slate-50 to-orange-50 pt-32 pb-20 px-4">
            <div className="max-w-4xl mx-auto">
               <div className="text-center mb-12">
                  <div className="inline-block px-4 py-2 bg-orange-100 rounded-full mb-6">
                     <span className="text-orange-600 font-bold">💰 REFUNDS And Cancellation</span>
                  </div>
                  <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">Refund & Cancellation Policy</h1>
                  <p className="text-xl text-gray-600">Our commitment to your satisfaction</p>
               </div>

               <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 border-2 border-gray-200">
                  {refundPolicyContent ? (
                     <div
                        className="prose prose-lg max-w-none"
                        dangerouslySetInnerHTML={{ __html: refundPolicyContent }}
                     />
                  ) : (
                     <div className="prose prose-lg max-w-none">
                        <div className="mb-8 p-6 bg-green-100 rounded-2xl border border-green-300">
                           <div className="flex items-center gap-3">
                              <CheckCircle className="w-8 h-8 text-green-600" />
                              <div>
                                 <h3 className="font-bold text-green-800 text-lg">30-Day Money-Back Guarantee</h3>
                                 <p className="text-green-700">
                                    We offer a full refund within 30 days of purchase if you're not satisfied.
                                 </p>
                              </div>
                           </div>
                        </div>

                        <section className="mb-8">
                           <h2 className="text-3xl font-black text-gray-900 mb-4">Refund Eligibility</h2>
                           <div className="space-y-4">
                              <div className="flex items-start gap-3 p-4 bg-blue-50 rounded-xl">
                                 <Check className="w-6 h-6 text-green-600 mt-1 flex-shrink-0" />
                                 <div>
                                    <h4 className="font-bold text-gray-900">Qualifies for Refund</h4>
                                    <ul className="text-gray-700 text-sm space-y-1 mt-2">
                                       <li>• Service doesn't work as advertised</li>
                                       <li>• Technical issues we cannot resolve</li>
                                       <li>• Duplicate or accidental purchases</li>
                                    </ul>
                                 </div>
                              </div>
                              <div className="flex items-start gap-3 p-4 bg-red-50 rounded-xl">
                                 <X className="w-6 h-6 text-red-600 mt-1 flex-shrink-0" />
                                 <div>
                                    <h4 className="font-bold text-gray-900">Doesn't Qualify for Refund</h4>
                                    <ul className="text-gray-700 text-sm space-y-1 mt-2">
                                       <li>• Change of mind after 30 days</li>
                                       <li>• Not using the purchased features</li>
                                       <li>• GST filing errors due to incorrect data provided</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </section>

                        <section className="mb-8">
                           <h2 className="text-3xl font-black text-gray-900 mb-4">How to Request a Refund</h2>
                           <div className="space-y-4">
                              <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl">
                                 <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                                    1
                                 </div>
                                 <p className="text-gray-700">Contact our support team at support@zeronine.com</p>
                              </div>
                              <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl">
                                 <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                                    2
                                 </div>
                                 <p className="text-gray-700">Provide your account details and reason for refund</p>
                              </div>
                              <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl">
                                 <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                                    3
                                 </div>
                                 <p className="text-gray-700">We'll process your refund within 5-7 business days</p>
                              </div>
                           </div>
                        </section>

                        <section className="mb-8">
                           <h2 className="text-3xl font-black text-gray-900 mb-4">Free Trial</h2>
                           <p className="text-gray-700 mb-4 leading-relaxed">
                              Our 14-day free trial requires no payment information and automatically expires without
                              any charges. You can upgrade to a paid plan at any time during or after the trial period.
                           </p>
                        </section>
                     </div>
                  )}
               </div>
            </div>
         </div>
         <Footer />
      </>
   );
};

export default RefundPolicy;
